import { connect, mapProps } from '@formily/react';
import { CnDepartmentSelect as UiDepartmentSelect, } from '@/components/cn-department-select';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnDepartmentSelect = connect(UiDepartmentSelect, mapProps(mapSize, mapStatus));
CnDepartmentSelect.displayName = 'CnDepartmentSelect';
